import { useEffect, useState } from "react";
import {
  addReservedSubTimesFromPanel,
  getReservationFillTime,
} from "../../api/routes";
import { Checkbox, Modal } from "@mui/material";
import MDBox from "../../components/MDBox";
import Loading from "../../components/Loading";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import queryString from "../../components/queryString";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  borderRadius: 4,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function FillTimeModal({ modal, setTrigger, handleClose }) {
  const [loading, setLoading] = useState(false);
  const [information, setInformation] = useState({});
  const handleChange = (event) => {
    const { name, value } = event.target;
    setInformation({ ...information, [name]: value });
  };
  useEffect(() => {
    if (modal?.reservedSubTimesId) {
      const query = {
        reservedSubTimesId: modal?.reservedSubTimesId,
      };
      setLoading(true);
      getReservationFillTime(queryString(query), (isOk, data) => {
        if (!isOk) {
          setLoading(false);
          return toast.error(data.message);
        } else {
          setLoading(false);
          setInformation({
            fullname: data.data[0].fullname,
            phoneNumber: data.data[0].phoneNumber,
            isReserved: modal.data.isReserved,
          });
        }
      });
    } else {
      setInformation({
        isReserved: modal.data.isReserved,
      });
    }
  }, [modal?.reservedSubTimesId]);
  const updateNoteBook = () => {
    setLoading(true);
    const data = { ...modal.data, ...information };

    addReservedSubTimesFromPanel(data, (isOk, data) => {
      setLoading(false);
      if (!isOk) {
        return toast.error(data.message);
      } else {
        handleClose()
        setTrigger(Math.random());
        toast.success("تغییرات اعمال شد!");
      }
    });
  };

  return (
    <Modal
      open={modal.state}
      onClose={handleClose}
    >
      <MDBox sx={style} pt={4} pb={3} px={3}>
        <Loading loading={loading} />
        <MDBox>
          <MDInput type="text" name={"fullname"} value={information.fullname}
                   onChange={handleChange}
                   label="نام و نام خانوادگی" fullWidth />
        </MDBox>
        <MDBox mt={1}>
          <MDInput type="text" name={"phoneNumber"} value={information.phoneNumber}
                   onChange={handleChange}
                   label="شماره موبایل" fullWidth />
        </MDBox>
        <MDBox mt={1} style={{ display: "flex", alignItems: "center" }}>
          <Checkbox color="secondary" checked={information.isReserved}
                    onChange={(event) => setInformation({ ...information, isReserved: event.target.checked })} />
          <p style={{ fontSize: 16 }}>پر کردن تایم</p>
        </MDBox>
        <MDBox mt={2}>
          <MDButton onClick={updateNoteBook} variant="gradient" color="success" sx={{ width: "100%" }}>
            ثبت
          </MDButton>
        </MDBox>
      </MDBox>
    </Modal>
  );
}
